import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISerieDetail } from "src/models/General/Serie.models";

interface serieDetailstate {
  serieDetails: ISerieDetail[];
  serieDetailToEdit: ISerieDetail | null;
}

const initialState: serieDetailstate = {
  serieDetails: [],
  serieDetailToEdit: null,
};

const serieDetailSlice = createSlice({
  name: "SerieDetail",
  initialState,
  reducers: {
    setSerieDetailList: (state, action: PayloadAction<ISerieDetail[]>) => {
      state.serieDetails = action.payload;
    },
    concatListSerieDetail: (
      state: serieDetailstate,
      action: PayloadAction<ISerieDetail[]>
    ) => {
      state.serieDetails = [...state.serieDetails.concat(action.payload)];
    },
    setSerieDetailToEdit: (
      state,
      action: PayloadAction<ISerieDetail | null>
    ) => {
      state.serieDetailToEdit = action.payload;
    },
    addSerieDetail: (state, action: PayloadAction<ISerieDetail>) => {
      state.serieDetails.push(action.payload);
    },
    updateSerieDetail: (state, action: PayloadAction<ISerieDetail>) => {
      let itemIndex = state.serieDetails.findIndex(
        item => item.serieDetailId === action.payload.serieDetailId
      );
      if (itemIndex !== -1) state.serieDetails[itemIndex] = action.payload;
    },
    deleteSerieDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.serieDetails.filter(
        item => item.serieDetailId !== action.payload
      );
      state.serieDetails = newArray;
    },
  },
});

export const {
  setSerieDetailList,
  concatListSerieDetail,
  setSerieDetailToEdit,
  addSerieDetail,
  updateSerieDetail,
  deleteSerieDetail,
} = serieDetailSlice.actions;

export default serieDetailSlice.reducer;
